<template>
  <div class="content-wrapper" style="min-height: 481px;">
    <section class="content-header">
      <h1>
        {{ $t('camps.title') }}
        <small>{{ $t('camps.subtitle') }}</small>
      </h1>
      <ol class="breadcrumb">
        <li><i class="fa fa-dashboard"></i> <a href="./">Dashboard</a></li>
        <li class="active">{{ $t('camps.title') }}</li>
      </ol>
    </section>

    <section class="content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div v-if="$root.$i18n.locale === 'en'" class="callout callout-info">
            <p>The term “Sports Camp” is used to describe the organization as a whole. It must have a Name and an address.</p>

            <p>You can review and edit the information on the Sports Camp here.</p>
          </div>
          <div v-if="$root.$i18n.locale === 'ru'" class="callout callout-info">
            <p>Спортивный Лагерь - это спортивная организация в целом.</p>
            <p>Здесь вы можете просматривать и редактировать информацию о Спортивном Лагере.</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid">
            <div class="box-body">
              <div class="box-group" id="accordion">
                <div
                  class="panel box box-primary"
                  v-for="camp in camps"
                  :key="camp.id"
                >
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a data-toggle="collapse" v-on:click="setCurrentCamp(camp)" data-parent="#accordion" :href="'#collapse' + camp.id"
                         aria-expanded="false" class="collapsed">
                        {{camp.name[$root.$i18n.locale]}}
                      </a>
                    </h4>
                  </div>
                  <div :id="'collapse' + camp.id" class="panel-collapse collapse" aria-expanded="false" style="">
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-8">
                          <div class="box-body">
                            <p class="text-green">{{ $t('camps.camp-item.current-version') }}</p>
                            <strong>{{camp.name[$root.$i18n.locale]}}</strong><br>
                            <a target="_blank" :href="'https://sportlane.com/en/search?camp=' + camp.urlName">
                              https://sportlane.com/en/search?camp={{camp.urlName}}
                            </a>
                          </div>
                        </div>

                        <div v-if="isBackoffice()" class="col-sm-4">
                          <div>
                            <a v-on:click="setCurrentCamp(camp)" data-toggle="modal" data-target="#modal-agent">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua"><i class="fa fa-book"></i></span>
                                <div class="info-box-content">
                                  <span class="info-box-text">Представители</span>
                                  <span class="info-box-number"><small></small></span>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div>
                            <a v-on:click="setCurrentFinInfoCamp(camp)" data-toggle="modal"
                               data-target="#modal-fin-info">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua"><i class="fa fa-book"></i></span>
                                <div class="info-box-content">
                                  <span class="info-box-text">Финансовая информация</span>
                                  <span class="info-box-number"><small></small></span>
                                </div>
                              </div>
                            </a>
                          </div>
<!--                          <div>-->
<!--                            <a v-on:click="openFaqs(camp)" data-toggle="modal"-->
<!--                               data-target="#modal-faqs">-->
<!--                              <div class="info-box">-->
<!--                                <span class="info-box-icon bg-aqua"><i class="fa fa-book"></i></span>-->
<!--                                <div class="info-box-content">-->
<!--                                  <span class="info-box-text">FAQ</span>-->
<!--                                  <span class="info-box-number"><small></small></span>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </div>-->
                        </div>

<!--                        <div v-if="!isBackoffice()" class="col-sm-4">-->
<!--                          <div>-->
<!--                            <a v-on:click="openFaqs(camp)" data-toggle="modal"-->
<!--                               data-target="#modal-faqs">-->
<!--                              <div class="info-box">-->
<!--                                <span class="info-box-icon bg-aqua"><i class="fa fa-book"></i></span>-->
<!--                                <div class="info-box-content">-->
<!--                                  <span class="info-box-text" v-html="$t('camps.blocks.faqs')"></span>-->
<!--                                  <span class="info-box-number"><small></small></span>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
                      </div>

                      <hr>

                      <div class="row">
                        <div class="col-sm-12">
                          <h2 class="page-header">
                            {{ $t('camps.camp-item.edit') }}
                            <small class="pull-right"></small>
                          </h2>
                        </div>
                      </div>

                      <div v-if="isBackoffice()" class="row">
                        <div class="col-sm-6">
                          <EditCampComponent
                            v-bind:language="'en'"
                            v-bind:current-camp="currentCamp">
                          </EditCampComponent>
                        </div>
                        <div class="col-sm-6">
                          <EditCampComponent
                            v-bind:language="'ru'"
                            v-bind:current-camp="currentCamp">
                          </EditCampComponent>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col-sm-12">
                          <EditCampComponent
                            v-bind:language="$root.$i18n.locale"
                            v-bind:current-camp="currentCamp">
                          </EditCampComponent>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="box-body">
                            <button v-on:click="saveCamp" type="button" class="btn btn-block btn-success">
                              {{ $t('camps.camp-item.save') }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="box-footer">
              <button v-if="isBackoffice()" type="submit" data-toggle="modal" data-target="#modal-new-camp" class="btn btn-info pull-right">
                Создать новый лагерь
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CampAgentsComponent
      v-bind:current-camp="currentCamp">
    </CampAgentsComponent>

    <CampFinInfoComponent
      v-bind:current-camp="currentCamp"
      v-bind:current-fin-info="currentFinInfo">
    </CampFinInfoComponent>

    <AddCampComponent
      v-bind:countries="countries">
    </AddCampComponent>

    <CampFaqsComponent></CampFaqsComponent>
  </div>
</template>

<script>
import CampAgentsComponent from './CampAgents';
import CampFinInfoComponent from './CampFinInfo';
import CampFaqsComponent from './CampFaqs';
import AddCampComponent from './AddCamp';
import EditCampComponent from './EditCamp';
import axios from 'axios';

export default {
  name: 'CampsContent',
  components: {
    CampAgentsComponent,
    CampFinInfoComponent,
    CampFaqsComponent,
    AddCampComponent,
    EditCampComponent
  },
  props: {
    camps: Array,
    countries: Array
  },
  created () {
    let self = this;

    self.$root.$on('updateCamp', function (camp) {
      axios.get(
        window.host + '/camps')
        .then(function (response) {
          let cs = response.data;

          for (var i = 0; i < cs.length; i++) {
            if (cs[i].id === camp.id) {
              self.currentCamp = cs[i];

              let currentAuthorizesAgents = [];
              let authorizesAgents = [];

              axios.get(
                window.host + '/authorizesAgents')
                .then(function (response) {
                  console.log(response.data);
                  authorizesAgents = response.data;

                  for(let q = 0; q < response.data.length; q ++){
                    for(let c = 0; c < response.data[q].campIds.length; c++){
                      if(response.data[q].campIds[c] === camp.id){
                        currentAuthorizesAgents.push(response.data[q]);
                      }
                    }
                  }

                  self.currentCamp = {
                    id: camp.id,
                    name: {
                      en: camp.name.en,
                      ru: camp.name.ru
                    },
                    address: {
                      ru: camp.address.ru,
                      en: camp.address.en
                    },
                    countryId: camp.countryId,
                    urlName: camp.urlName,
                    currentAuthorizesAgents: currentAuthorizesAgents,
                    authorizesAgents: authorizesAgents
                  };
                })
                .catch(function (error) {
                  console.log(error);
                });


            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  },
  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  data () {
    return {
      currentCamp: {
        name: {
          en: '',
          ru: ''
        }
      },
      currentFinInfo: {},
      faqs: [],
      currentAuthorizesAgents: [],
      authorizesAgents: []
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    setCurrentCamp: function (camp) {
      console.log(camp);

      let self = this;

      let currentAuthorizesAgents = [];
      let authorizesAgents = [];

      axios.get(
        window.host + '/authorizesAgents')
        .then(function (response) {
          console.log(response.data);
          authorizesAgents = response.data;

          for(let q = 0; q < response.data.length; q ++){
            for(let c = 0; c < response.data[q].campIds.length; c++){
              if(response.data[q].campIds[c] === camp.id){
                currentAuthorizesAgents.push(response.data[q]);
              }
            }
          }

          self.currentCamp = {
            id: camp.id,
            name: {
              en: camp.name.en,
              ru: camp.name.ru
            },
            address: {
              ru: camp.address.ru,
              en: camp.address.en
            },
            countryId: camp.countryId,
            urlName: camp.urlName,
            currentAuthorizesAgents: currentAuthorizesAgents,
            authorizesAgents: authorizesAgents
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setCurrentFinInfoCamp (camp) {
      this.setCurrentCamp(camp);

      let self = this;

      axios.get(
        window.host + '/camps/' + this.currentCamp.id + '/finincialInformation')
        .then(function (response) {
          console.log(response.data);

          if (response.data === '') {
            self.currentFinInfo = {
              currency: 'RUB',
              mediumTermComission: 0,
              longTermComission: 0
            };
          } else {
            self.currentFinInfo = {
              currency: response.data.defaultCurrency.codeISO,
              mediumTermComission: response.data.campComission.mediumTermComission.value,
              longTermComission: response.data.campComission.longTermComission.value
            };
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    openFaqs: function (camp) {
      this.$root.$emit('showCampFaqs', camp.id);
    },
    saveCamp: function () {
      let self = this;

      for (let i = 0; i < this.camps.length; i++) {
        if (this.camps[i].id === this.currentCamp.id) {
          let newCamp = {
            id: this.currentCamp.id,
            name: {
              en: this.currentCamp.name.en,
              ru: this.currentCamp.name.ru
            },
            urlName: this.currentCamp.urlName
          };

          console.log(newCamp);

          axios.put(
            window.host + '/camps/'+this.currentCamp.id, newCamp)
            .then(function (response) {
              console.log(response.data);
              self.$root.$emit('alert', 'success', 'alert.success');
            })
            .catch(function (error) {
              console.log(error);
              self.$root.$emit('alert', 'error', 'alert.error');
            });

          this.$set(this.camps, i, newCamp);
        }
      }
    }
  }
};
</script>

<style scoped>

</style>
